import { createContext, useContext, useState } from 'react';

import { GlobalContextType, GlobalProviderProps, TabsState } from './types/global.types';

export const GlobalContext = createContext(null);

export const GlobalProvider = ({ children, serviceOSSettings }: GlobalProviderProps) => {
  const [tabsState, setTabsState] = useState<TabsState>({});

  const setTabIndex = (tabsName: string, index: number) => {
    setTabsState((prevState) => ({
      ...prevState,
      [tabsName]: index,
    }));
  };

  return (
    <GlobalContext.Provider value={{ tabsState, setTabIndex, serviceOSSettings }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalProviderContext = (): GlobalContextType => {
  const context = useContext(GlobalContext);

  if (context === undefined) {
    throw new Error('Hook useGlobalProviderContext must be used within a GlobalProvider component');
  }

  return context;
};
